export const SET_BACKDROP = "SET_BACKDROP";

export const setBackdrop = (payload) => {
	return {
		type: SET_BACKDROP,
		payload,
	};
};
